import styled, { keyframes } from 'styled-components'
import { colors, updatedMedia } from 'client/styles'
import { ListItemBase } from 'src/comps/ListItem/styles'
import { ButtonPrimary } from 'src/comps/Button/styles'
import { CreditCardInfoBase } from 'src/comps/CreditCardInfo/styles'
import s4lColors from 'src/styles/colors/colors'

export const PaymentFormBase = styled.div`
  font-size: 14px;
  line-height: 140%;
  color: ${colors.grey2};
  background: ${colors.white};
  padding-block: 20px;
  padding-inline: 20px;

  ${updatedMedia.desktop} {
    border: 2px solid ${colors.grey4};
    border-radius: 8px;
  }
`

export const Iframe = styled.iframe`
  width: 100%;
  height: 400px;
`

export const CreditCardFormContainer = styled.div`
  width: 100%;

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    box-shadow: 0 0 0 30px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  iframe#payment-form-iframe {
    min-height: 350px;
  }

  ${updatedMedia.desktop} {
    iframe#payment-form-iframe {
      min-height: auto;
    }
  }
`

export const ConditionsMessage = styled.div`
  padding-block: 20px;
  padding-inline: 20px;
  margin-block-end: 20px;
  border-radius: 8px;
  font-size: 16px;
  line-height: 150%;
  color: ${colors.grey2};
  border: 2px solid ${colors.grey4};
  border-radius: 8px;

  ${ListItemBase} {
    padding-block-start: 12px;
    padding-block-end: 0;
  }
`

export const ConditionsMessageTitle = styled.div`
  display: flex;
  margin-block-end: 12px;

  svg {
    margin-inline-end: 10px;
    fill: ${colors.grey2};
  }
`

const pulse = keyframes`
  0% {
    opacity: 0.5
  }

  50% {
    opacity: 1
  }

  100% {
    opacity: 0.5
  }
`

export const ConfirmationContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 335px;
  text-align: center;
  margin-inline: auto;
  margin-block: 0;
  padding-block: 16px 32px;
  padding-inline: 0;
  font-size: 16px;
  line-height: 24px;
  animation: ${pulse} 1.2s ease-out;
  animation-iteration-count: infinite;

  svg {
    fill: ${colors.grey1};
  }
`

export const ConfirmationTitle = styled.div`
  margin-block: 12px;
  margin-inline: 0;
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
  color: ${colors.grey1};
`

export const CreditCardOption = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 24px;

  svg {
    margin-inline-end: 8px;
    fill: ${colors.grey2};
  }
`

export const SavedCreditCardSection = styled.div`
  ${CreditCardInfoBase} {
    margin-block-end: 20px;
  }
`

export const ChangeCreditCardButton = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey1};
  padding-block: 10px;
  padding-inline: 0;
  text-decoration-line: underline;
  cursor: pointer;
  margin-block-end: 20px;
`

export const CancelChangeCreditCardButton = styled(ChangeCreditCardButton)``

export const ConfirmBookingSubmit = styled(ButtonPrimary)`
  background-color: ${props => (props.isPrime ? s4lColors.prime2 : s4lColors.brand1)};
  font-size: 16px;

  &:hover {
    background-color: ${props => (props.isPrime ? s4lColors.prime4 : s4lColors.brand2)};
  }

  width: 100%;

  ${updatedMedia.tablet} {
    width: auto;
  }
`
